import { render } from "./UiToggle.vue?vue&type=template&id=b371f13c"
import script from "./UiToggle.vue?vue&type=script&lang=js"
export * from "./UiToggle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__